export const urlLanguajeRegex = /\/|\/es\/|\/pr\//i;

export const n5BlogUrl = "https://blog.n5now.com/";
export const contentLiteral = "content/";
